// extracted by mini-css-extract-plugin
export default {"noImgWrapper":"styles_noImgWrapper__k0Op+","dark":"styles_dark__1SwMv","imageIcon":"styles_imageIcon__3Fr8R"};